// extracted by mini-css-extract-plugin
module.exports = {"specifications":"styles_specifications__2wad_","specifications_item":"styles_specifications_item__2-azV","specifications_title":"styles_specifications_title__1LU5L"};